import CrmGoogleMap from './crm-google-map'
export { CrmGoogleMap }
